import mixitup from "./autoload/mixitup.min";
import mixitupPagination from "./autoload/mixitup-pagination.min";
import mixitupMultifilter from "./autoload/mixitup-multifilter.min"; //import Dropdown from './dropdown';

var Filtering = function Filtering() {
  var mixer = mixitup('.js-filtering', {
    load: {
      filter: '.all'
    },
    callbacks: {
      onMixStart: function onMixStart(state) {
        // remove the animation class
        $('.mix').removeClass('fc-mixer-end'); // trigger items reflow

        $('.mix').width();
      },
      onMixEnd: function onMixEnd(state) {
        // add the animation class
        $('.mix').addClass('fc-mixer-end');
      }
    },
    animation: {
      enable: false
    }
  });
};

export default Filtering;